import React, {createContext, useEffect, useState, useMemo } from "react"
import { useLocation } from '@reach/router';
import useCookie from "../hooks/useCookie";
import CookieBanner from "../components/CookieBanner/CookieBanner";
import {uniqueID} from "./../utils/utilityFunctions";


export const CookieConsentContext = createContext(null);

const CookieConsentComponent = ({ children, data }) => {

 	
	const [userConsentCookie] = useCookie(process.env.GATSBY_USER_CONSENT_COOKIE);
	const [userCookie, setUserCookie] = useCookie(process.env.GATSBY_USER_COOKIE);

	const location = useLocation();
	const [showConsent, setShowConsent] = useState(false);
	const [forcedConsent, setForcedConsent] = useState(false);
	const value = useMemo(() => [forcedConsent, setForcedConsent], [forcedConsent]);

	if(!userCookie) {
		setUserCookie(uniqueID())
	} 
	
	useEffect(() => {
		if(forcedConsent) {
			setShowConsent(true);
		} else {
			setShowConsent(false);
		}
	}, [forcedConsent])

	useEffect(() => {
		if(userConsentCookie) {
			setShowConsent(false);
		} else {
			if(location.pathname !== "/cookie/") {
				setShowConsent(true);
			}
		}
	}, [])

  	return(
		<CookieConsentContext.Provider value={value}>
			{children}
			{(showConsent)?<CookieBanner data={data.data}  showConsent={showConsent}/>:<></>}
		</CookieConsentContext.Provider>
  	)
}

// Wrapper component
const CookieConsent = ({ children , data }) => {
  return(
      <CookieConsentComponent data={data}>
        {children}
      </CookieConsentComponent>
  )
}

export default CookieConsent
